 const CONFIG = {
   BASE_API_URL: getBackendUrl(),
 };

 function getBackendUrl () {
   if (window.location.hostname.startsWith('timesheet.hays')) {
     return process.env.VUE_APP_API_URL_PROD;
   } else {
     return process.env.VUE_APP_API_URL
   }

 }
export default CONFIG;
